import { DomainError } from '@dma/shared';

export class InvalidServiceError extends DomainError {
  constructor(reason: string) {
    super('INVALID_SERVICE', `Service is invalid: ${reason}`);
    this.name = 'InvalidServiceError';
    Object.setPrototypeOf(this, InvalidServiceError.prototype);
  }
}
